/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import React, { useState } from 'react';
import { Button } from '../Button';
import { Link } from '../Link';
import { Logo } from '../Logo';
import './style.css';

import { LogoPartner } from '../LogoPartner';

import { useNavigate } from 'react-router-dom';
import { NavMenuButton } from '../../icons/NavMenuButton';

export const HeaderMobile = ({
    className,
    logoDimensions,
    shareFeedbackEmailAddress,
}) => {
    const navigate = useNavigate();
    const [open, setOpen] = useState(false);

    function renderOverlay() {
        return (
            <div className="header-overlay">
                <div className="nav">
                    <div className="links">
                        <Link
                            className="link-item"
                            text="Materialien"
                            onClick={() => {
                                navigate('/directory');
                            }}
                        />
                        <Link
                            className="link-item"
                            text="Das Projekt"
                            onClick={() => {
                                navigate('/project');
                            }}
                        />
                        <Link
                            className="link-item"
                            text="FAQ"
                            onClick={() => {
                                navigate('/faq');
                            }}
                        />
						<Link
                            className="link-item"
                            text="eduBuzz"
                            onClick={() => {
								window.open("https://edubuzz.tuecede.de", '_blank').focus();
                            }}
                        />
                    </div>

                    <Button
                        className="feedback-button"
                        status="default"
                        style="secondary"
                        textLink="Feedback teilen"
                        onClick={(e) => {
                            window.location =
                                'mailto:' + shareFeedbackEmailAddress;
                        }}
                    />
                </div>
            </div>
        );
    }

    return (
        <div className={`header ${className} ${open ? 'header-open' : ''}`}>
            <div className="frame">
                <div
                    className="logo-wrapper"
                    style={{ display: 'inline-block' }}
                >
                    <Logo
                        className="logo"
                        logo="DUO"
                        logoDimensions={logoDimensions}
                        style={{
                            cursor: 'pointer',
                            colour: 'default',
                            float: 'left',
                        }}
                        onClick={() => {
                            navigate('/');
                        }}
                    />
                    <LogoPartner
                        className="design-component-instance-node-8 header-partner"
                        color="default"
                        lernenDigital="/img/lernen-digital-transferstelle-anthrazit-rgb-1-2x.png"
                        partner="lernen-digital"
                        size="mobile"
                    />
                    <LogoPartner
                        className="design-component-instance-node-8 header-partner"
                        color="black"
                        partner="uni-t-b"
                        size="mobile"
                    />
                </div>

                <div className="frame-right">
                    <button
                        className="header-hamburger"
                        type="button"
                        onClick={() => setOpen((p) => !p)}
                    >
                        <NavMenuButton open={open} />
                    </button>
                </div>

                {renderOverlay()}
            </div>
        </div>
    );
};

HeaderMobile.propTypes = {};
